import _ from 'underscore';

import * as navigation from 'Navigation';

class ProteinComplexPropertiesTabState extends navigation.TabState {
  constructor({proteinIds}: {proteinIds: Array<string>}) {
    super();
    this.set('proteinIds', proteinIds);
  }

  override defaults(): navigation.TabStateDefaults {
    // eslint-disable-next-line no-restricted-syntax
    return _.extend(super.defaults(), {
      title: 'AA Sequence Properties',
      closeable: true,
    });
  }
}

export {ProteinComplexPropertiesTabState as tabState};
